import { render, staticRenderFns } from "./NovedadesExport.vue?vue&type=template&id=769ff398"
import script from "./NovedadesExport.vue?vue&type=script&lang=js"
export * from "./NovedadesExport.vue?vue&type=script&lang=js"
import style0 from "./NovedadesExport.vue?vue&type=style&index=0&id=769ff398&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports